import React from 'react'

export const MainContext = React.createContext({ test: 'test!'})

export const MainContextProvider = MainContext.Provider